export const MOST_POPULAR = {
    PARENT_PART_TYPE_ID: '00000',
    PLATFORM_ID: '99',
};

export const SignalsEventTypes = {
    CLICK: 'CLICK',
    ADD_TO_QUOTE: 'CART',
    PURCHASE: 'PURCHASE',
};

export const SignalsSearchSource = {
    FREE_TEXT: 'FREE_TEXT',
    SUGGESTION: 'SUGGESTION',
    CATEGORY_NAV: 'CATEGORY_NAV',
};

export const ProductOrigin = {
    CATALOG: 'CATALOG',
    DIRECT: 'DIRECT',
    STOCK_ORDER: 'STOCK_ORDER',
    INTERCHANGE: 'INTERCHANGE',
    MANUAL: 'MANUAL',
    CROSS_SELL_PR_PRODUCT: 'CROSS_SELL_PR_PRODUCT',
    CROSS_SELL_PT_PRODUCT: 'CROSS_SELL_PT_PRODUCT',
    SUPPLIES: 'SUPPLIES',
    KEYWORD: 'KEYWORD',
};

export const ProductFitCompatibility = {
    UNKNOWN: 'UNKNOWN',
    COMPATIBLE: 'COMPATIBLE',
    INCOMPATIBLE: 'INCOMPATIBLE',
};

export const ProductOriginDetails = {
    SEARCH_RESULTS_PART_TYPE: 'SEARCH_RESULTS_PART_TYPE',
};

export const SEARCH_RESULTS_PART_TYPE_NAME = 'SEARCH_PART_TYPE_NAME';

export const ProductKeyType = {
    LEGACY: 'LEGACY',
};

export const ProductSortValues = {
    PRICE: 'PRICE',
    AVAILABILITY: 'AVAILABILITY',
    ASCENDING: 'ASCENDING',
    DESCENDING: 'DESCENDING',
    RELEVANCE: 'SCORE',
};

export const KitLookupTypes = {
    BRAKE: 'BRAKE',
    AC: 'AC',
};

export const KitLookupPartTypeIds = {
    AC: 'C4576',
    BRAKE: 'C4577',
};

export const PartTypeSearchLimit = {
    FIRST_15: 15,
    ALL: -1,
};

export const EntSearchPartTypeSearchLimit = {
    FIRST_15: 15,
    ALL: 60,
};

export const PartTypeSearchSort = {
    POPULAR: 'rank',
    ALPHA: 'pt_name',
};

export const EntSearchPartTypeSearchSort = {
    POPULAR: 'RANK',
    ALPHA: 'NAME',
};

export const StoreError = {
    STORE_DOWN: 'STORE_DOWN',
};

export const WorksheetError = {
    WORKSHEET_LOCKED: 'WORKSHEET_LOCKED',
};

export const LookupOrigin = {
    TYPEAHEAD: 'typeahead',
    PREPROCESS: 'preprocess',
    SUGGESTION: 'suggestion',
    CATALOG: 'catalog',
    SUGGESTED_PART_MENU: 'suggestPartMenu',
    RELATED: 'related',
};

export const CatalogTabOrigins = {
    POPULAR: 'POPULAR',
    ALL: 'ALL',
    PACKAGE_JOBS: 'PACKAGEJOBS',
};

export const PlatformId = {
    ALL_PART_TYPES: '05',
    MOST_POPULAR: '99',
    RELATED_PART_TYPES: '90',
};

export const PartTypeRequirements = {
    VEHICLE_REQUIRED: 'BASE_VEHICLE',
};

export const AttributeValues = {
    DONT_KNOW_SHOW_ALL: -99,
};

export const TypeAheadTypes = {
    PART_TYPE: 'PART_TYPE',
    VEHICLE: 'VEHICLE',
    CUSTOM_SEARCH_QUERY: 'CUSTOM_SEARCH_QUERY',
};

// used for analytics
export const SearchTechnology = {
    ENT_SEARCH: 'EntSearch',
    LEGACY: 'Legacy',
};

// used for analytics
export const LookupMethod = {
    TYPEAHEAD: 'Type Ahead',
    PREPROCESSING: 'Pre-Processing',
    MOST_POPULAR: 'Most Popular',
    ALL_PARTS: 'All Parts',
    PACKAGE_JOBS: 'Package Job',
    SELECT_MULTIPLE: 'Select Multiple',
    SEARCH_MY_KEYWORD: 'Search My Keyword',
    ITEM_NUMBER_SEARCH: 'Item Number Search',
    RELEVANCY_SEARCH: 'Relevancy Search',
    SUGGESTED_PART_TYPE: 'Suggested Part Type',
    INTERCHANGE: 'Interchange',
    BASED_ON_YOUR_SEARCH: 'Based on Your Search',
    RELATED_PART_TYPES: 'Related Part Type',
    LEGACY_EXACT_MATCH: 'Legacy Exact Match',
};

// keywords value that identifies a part type as a specification banner
export const SpecificationKeyword = '1';

// used for analytics
export const Disposition = {
    SUCCESS: 'Success',
    FAIL: 'Fail',
};
